module.exports = __webpack_public_path__ + "static/media/YF47_5.10c912a9.jpg";